/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
'use strict';

class DatosGenerales {
  constructor($scope, Util, Proyecto, Modal, _, DataService, Message, $http,subDomain, baseUrl) {
    'ngInject';
    this.$http = $http;
    this.$scope = $scope;
    this.Util = Util;
    this.Proyecto = Proyecto;
    this.Modal = Modal;
    this._ = _;
    this.archivos = null;
    this.DataService = DataService;
    this.Message = Message;
    this.qrimage = null;
    this.subDomain = subDomain;
    this.baseUrl = baseUrl;
  }

  $onInit() {
    this.tipos_plazo_ampliado = [{
      codigo: 'Convenio modificatorio',
      nombre: 'Convenio modificatorio'
    },{
      codigo: 'Adenda al convenio',
      nombre: 'Adenda al convenio'
    }];
    // console.log(this.proyecto)
    this.generar();
    //this.opciones_plazo_administrativo = [{codigo:240,nombre:'240 días (8 meses)'},{codigo:255,nombre:'255 días (8 1/2 meses)'}];
    if (!this.proyecto.convenio) this.proyecto.convenio = {};
    this.proyecto.convenio.plazo_tiempo_administrativo = this.proyecto.financiamiento.plazo_tiempo_administrativo.codigo;
    this.proyecto.convenio.plazo_convenio_ampliado = this.proyecto.convenio.plazo_convenio_ampliado || 0;

    this.$scope.$watch('$ctrl.proyecto.convenio.plazo_tiempo_administrativo', () => {
      if (this.proyecto.convenio.plazo_tiempo_administrativo) {
        this.proyecto.convenio.plazo_convenio = this.proyecto.plazo_ejecucion + this.proyecto.convenio.plazo_tiempo_administrativo;
      }
    });

    this.archivos = {
      urlDocConvenio: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/C` : '',
      urlDocConvenioDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/C/descargar` : '',
      urlDocConvenioExtendido: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT` : '',
      urlDocConvenioExtendidoDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT/descargar` : '',
      urlDocConvenioExtendido2: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT2` : '',
      urlDocConvenioExtendidoDescarga2: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT2/descargar` : '',
      urlDocConvenioExtendido3: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT3` : '',
      urlDocConvenioExtendidoDescarga3: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT3/descargar` : '',
      urlDocConvenioExtendido4: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT4` : '',
      urlDocConvenioExtendidoDescarga4: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT4/descargar` : '',
      urlDocConvenioExtendido5: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT5` : '',
      urlDocConvenioExtendidoDescarga5: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT5/descargar` : '',
      urlDocConvenioExtendido6: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT6` : '',
      urlDocConvenioExtendidoDescarga6: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT6/descargar` : '',
      urlDocConvenioExtendido7: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT7` : '',
      urlDocConvenioExtendidoDescarga7: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT7/descargar` : '',
      urlDocConvenioExtendido8: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT8` : '',
      urlDocConvenioExtendidoDescarga8: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT8/descargar` : '',
      urlDocConvenioExtendido9: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT9` : '',
      urlDocConvenioExtendidoDescarga9: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT9/descargar` : '',
      urlDocConvenioExtendido10: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT10` : '',
      urlDocConvenioExtendidoDescarga10: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT10/descargar` : '',
      urlDocConvenioExtendido11: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT11` : '',
      urlDocConvenioExtendidoDescarga11: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT11/descargar` : '',
      urlDocConvenioExtendido12: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT12` : '',
      urlDocConvenioExtendidoDescarga12: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT12/descargar` : '',
      urlDocConvenioExtendido13: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT13` : '',
      urlDocConvenioExtendidoDescarga13: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT13/descargar` : '',
      urlDocConvenioExtendido14: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT14` : '',
      urlDocConvenioExtendidoDescarga14: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/CXT14/descargar` : '',
      urlDocResolucion: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/RM` : '',
      urlDocResolucionDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/RM/descargar` : ''
    };

    if (this.proyecto.orden_proceder) {
      this.diaActual = new Date();
      this.plazo_convenio0 = new Date(this.proyecto.orden_proceder);
      this.plazo_con_ampliaciones = new Date(this.proyecto.orden_proceder);

      this.plazo_amp1 = this.proyecto.convenio.plazo_convenio_ampliado ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado) : 0
      this.plazo_amp2 = this.proyecto.convenio.plazo_convenio_ampliado2 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado2) : 0
      this.plazo_amp3 = this.proyecto.convenio.plazo_convenio_ampliado3 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado3) : 0
      this.plazo_amp4 = this.proyecto.convenio.plazo_convenio_ampliado4 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado4) : 0
      this.plazo_amp5 = this.proyecto.convenio.plazo_convenio_ampliado5 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado5) : 0
      this.plazo_amp6 = this.proyecto.convenio.plazo_convenio_ampliado6 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado6) : 0
      this.plazo_amp7 = this.proyecto.convenio.plazo_convenio_ampliado7 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado7) : 0
      this.plazo_amp8 = this.proyecto.convenio.plazo_convenio_ampliado8 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado8) : 0
      this.plazo_amp9 = this.proyecto.convenio.plazo_convenio_ampliado9 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado9) : 0
      this.plazo_amp10 = this.proyecto.convenio.plazo_convenio_ampliado10 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado10) : 0
      this.plazo_amp11 = this.proyecto.convenio.plazo_convenio_ampliado11 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado11) : 0
      this.plazo_amp12 = this.proyecto.convenio.plazo_convenio_ampliado12 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado12) : 0
      this.plazo_amp13 = this.proyecto.convenio.plazo_convenio_ampliado13 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado13) : 0
      this.plazo_amp14 = this.proyecto.convenio.plazo_convenio_ampliado14 ? parseInt(this.proyecto.convenio.plazo_convenio_ampliado14) : 0
      // console.log(this.plazo_convenio0,'this.plazo_convenio0')
      // console.log(this.proyecto.plazo_ejecucion,'convenio plazoo')
      //  console.log(this.plazo_convenio.get(), 'getDate')
      // console.log(this.plazo_convenio0.getDate()+' + '+ parseInt(this.proyecto.convenio.plazo))
      this.plazo_convenio0.setDate(this.plazo_convenio0.getDate() + parseInt(this.proyecto.plazo_ejecucion))
      this.plazo_con_ampliaciones.setDate( this.plazo_con_ampliaciones.getDate() + parseInt(this.proyecto.plazo_ejecucion)+ this.plazo_amp1 + this.plazo_amp2 + this.plazo_amp3 + this.plazo_amp4 + this.plazo_amp5 + this.plazo_amp6 + this.plazo_amp7 + this.plazo_amp8 + this.plazo_amp9 + this.plazo_amp10 + this.plazo_amp11 + this.plazo_amp12 + this.plazo_amp13 + this.plazo_amp14);
      // console.log('firestoneeeeee ', this.plazo_convenio0)
      // this.fechaAlerta = new Date(this.plazo_convenio0);
      // this.fechaAlerta.setDate(this.fechaAlerta.getDate() - 30)

      // if(this.diaActual < this.fechaAlerta){
       
      //   this.Modal.alert('Plazo Convenio Vigente hasta: ' + new Date(this.plazo_convenio0))
      // }else{
      //   if(this.diaActual < new Date(this.plazo_convenio0)){
      //     this.Modal.alert('Faltan menos de 30 días para el vencimiento del plazo convenio:  '+ new Date(this.plazo_convenio0))
      //   }else{
      //     this.Modal.alert('Se ha vencido el plazo convenio el : ' + new Date(this.plazo_convenio0))
      //   }       
      // }
      // console.log(this.plazo_convenio0,"plazo_convenio0")
      // console.log(this.plazo_con_ampliaciones," plazo con ampliaciones")
      if(this.plazo_amp1){
        this.diasRestantes = Math.floor((this.plazo_con_ampliaciones - this.diaActual) / (1000*60*60*24));
      }else{
        this.diasRestantes =  Math.floor((this.plazo_convenio0 - this.diaActual) / (1000*60*60*24));
      }
      
      //this.Modal.alert('dias restantes sin ampliacion'+ this.diasRestantes) 
 

      
      if(this.diasRestantes > 0){
        this.Modal.alert('Falta '+ this.diasRestantes + ' días para el vencimiento del plazo convenio ')
      }else{
        if(this.diaActual > this.plazo_con_ampliaciones){
          this.Modal.alert('Se ha vencido el plazo convenio el : ' + new Date(this.plazo_con_ampliaciones))
        }else{
          this.Modal.alert('El plazo de convenio vence hoy: ' + new Date(this.plazo_con_ampliaciones));
        }
      }

      this.plazo_convenio0 = this.plazo_convenio0.toISOString();
    } else {
      this.plazo_convenio0 = null;
    }
    this.mostrar = true;
    this.recalcularPlazoConvenio1();
    this.recalcularPlazoConvenio2();
    this.recalcularPlazoConvenio3();
    this.recalcularPlazoConvenio4();
    this.recalcularPlazoConvenio5();
    this.recalcularPlazoConvenio6();
    this.recalcularPlazoConvenio7();
    this.recalcularPlazoConvenio8();
    this.recalcularPlazoConvenio9();
    this.recalcularPlazoConvenio10();
    this.recalcularPlazoConvenio11();
    this.recalcularPlazoConvenio12();
    this.recalcularPlazoConvenio13();
    this.recalcularPlazoConvenio14();
  }

  $onChanges() {
    this.$scope.$watch('$ctrl.proyecto.monto_fdi', () => {
      if (!this.proyecto) {
        return;
      }
      this.calcularMontoConvenio();
    });
    this.$scope.$watch('$ctrl.proyecto.monto_contraparte', () => {
      if (!this.proyecto) {
        return;
      }
      this.calcularMontoConvenio();
    });
  }

  calcularMontoConvenio() {
    this.proyecto.monto_total_convenio = this.Util.redondear((this.proyecto.monto_fdi ? this.proyecto.monto_fdi : 0) + (this.proyecto.monto_contraparte ? this.proyecto.monto_contraparte : 0));
  }

  recalcularPlazoConvenio1() {
    if (this.plazo_convenio0) {
      this.plazo_convenio1 = new Date(this.plazo_convenio0);
      this.plazo_convenio1.setDate(this.plazo_convenio1.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado))
      this.plazo_convenio1 = this.plazo_convenio1.toISOString();
    }
  }
  recalcularPlazoConvenio2() {
    if (this.plazo_convenio1 && this.proyecto.convenio.plazo_convenio_ampliado2>=0) {
      this.plazo_convenio2 = new Date(this.plazo_convenio1);
      this.plazo_convenio2.setDate(this.plazo_convenio2.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado2))
      this.plazo_convenio2 = this.plazo_convenio2.toISOString();
    }
  }
  recalcularPlazoConvenio3() {
    if (this.plazo_convenio2 && this.proyecto.convenio.plazo_convenio_ampliado3>=0) {
      this.plazo_convenio3 = new Date(this.plazo_convenio2);
      this.plazo_convenio3.setDate(this.plazo_convenio3.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado3))
      this.plazo_convenio3 = this.plazo_convenio3.toISOString();
    }
  }
  recalcularPlazoConvenio4() {
    if (this.plazo_convenio3 && this.proyecto.convenio.plazo_convenio_ampliado4>=0) {
      this.plazo_convenio4 = new Date(this.plazo_convenio3);
      this.plazo_convenio4.setDate(this.plazo_convenio4.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado4))
      this.plazo_convenio4 = this.plazo_convenio4.toISOString();
    }
  }
  recalcularPlazoConvenio5() {
    if (this.plazo_convenio4 && this.proyecto.convenio.plazo_convenio_ampliado5>=0) {
      this.plazo_convenio5 = new Date(this.plazo_convenio4);
      this.plazo_convenio5.setDate(this.plazo_convenio5.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado5))
      this.plazo_convenio5 = this.plazo_convenio5.toISOString();
    }
  }
  recalcularPlazoConvenio6() {
    if (this.plazo_convenio5 && this.proyecto.convenio.plazo_convenio_ampliado6>=0) {
      this.plazo_convenio6 = new Date(this.plazo_convenio5);
      this.plazo_convenio6.setDate(this.plazo_convenio6.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado6))
      this.plazo_convenio6 = this.plazo_convenio6.toISOString();
    }
  }
  recalcularPlazoConvenio7() {
    if (this.plazo_convenio6 && this.proyecto.convenio.plazo_convenio_ampliado7>=0) {
      this.plazo_convenio7 = new Date(this.plazo_convenio6);
      this.plazo_convenio7.setDate(this.plazo_convenio7.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado7))
      this.plazo_convenio7 = this.plazo_convenio7.toISOString();
    }
  }
  recalcularPlazoConvenio8() {
    if (this.plazo_convenio7 && this.proyecto.convenio.plazo_convenio_ampliado8>=0) {
      this.plazo_convenio8 = new Date(this.plazo_convenio7);
      this.plazo_convenio8.setDate(this.plazo_convenio8.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado8))
      this.plazo_convenio8 = this.plazo_convenio8.toISOString();
    }
  }
  recalcularPlazoConvenio9() {
    if (this.plazo_convenio8 && this.proyecto.convenio.plazo_convenio_ampliado9>=0) {
      this.plazo_convenio9 = new Date(this.plazo_convenio8);
      this.plazo_convenio9.setDate(this.plazo_convenio9.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado9))
      this.plazo_convenio9 = this.plazo_convenio9.toISOString();
    }
  }
  recalcularPlazoConvenio10() {
    if (this.plazo_convenio9 && this.proyecto.convenio.plazo_convenio_ampliado10>=0) {
      this.plazo_convenio10 = new Date(this.plazo_convenio9);
      this.plazo_convenio10.setDate(this.plazo_convenio10.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado10))
      this.plazo_convenio10 = this.plazo_convenio10.toISOString();
    }
  }
  recalcularPlazoConvenio11() {
    if (this.plazo_convenio10 && this.proyecto.convenio.plazo_convenio_ampliado11>=0) {
      this.plazo_convenio11 = new Date(this.plazo_convenio10);
      this.plazo_convenio11.setDate(this.plazo_convenio11.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado11))
      this.plazo_convenio11 = this.plazo_convenio11.toISOString();
    }
  }
  recalcularPlazoConvenio12() {
    if (this.plazo_convenio11 && this.proyecto.convenio.plazo_convenio_ampliado12>=0) {
      this.plazo_convenio12 = new Date(this.plazo_convenio11);
      this.plazo_convenio12.setDate(this.plazo_convenio12.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado12))
      this.plazo_convenio12 = this.plazo_convenio12.toISOString();
    }
  }
  recalcularPlazoConvenio13() {
    if (this.plazo_convenio12 && this.proyecto.convenio.plazo_convenio_ampliado13>=0) {
      this.plazo_convenio13 = new Date(this.plazo_convenio12);
      this.plazo_convenio13.setDate(this.plazo_convenio13.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado13))
      this.plazo_convenio13 = this.plazo_convenio13.toISOString();
    }
  }
  recalcularPlazoConvenio14() {
    if (this.plazo_convenio13 && this.proyecto.convenio.plazo_convenio_ampliado14>=0) {
      this.plazo_convenio14 = new Date(this.plazo_convenio13);
      this.plazo_convenio14.setDate(this.plazo_convenio14.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado14))
      this.plazo_convenio14 = this.plazo_convenio14.toISOString();
    }
  }
  generar() {
    console.log(window.location.origin+this.subDomain+`#!/consultasqr/`+this.proyecto.codigo)
    const datos = {
      url: window.location.origin+this.subDomain+`#!/consultasqr/`+this.proyecto.codigo
    }
    console.log("datos",datos);
    this.$http({
      method: 'POST',
      url: this.baseUrl+`proyect/scan`,
      data: datos
    }).then((response)=>{
      this.qrimage = response.data.datos
      // console.log(response.data.datos)
    })
    /*this.DataService.post(`proyect/scan`,datos)
      .then(response=>{
        if(response){
          this.Message.success('QR Generado Correctamente...')
        }
      })*/
  }
}

export default DatosGenerales;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/convenio/convenio.controller.js